import angular from 'angular';

export class TabController {
  static $inject = ['$element'];
  tabsCtrl: { registerTab: (tab: TabController) => void; selectTab: (tab: TabController) => void };
  name: string;
  title: string;
  selected: boolean;

  constructor(public $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-tab');

    if (!this.name) {
      throw new Error('acmeTab.name is required');
    }

    this.tabsCtrl.registerTab(this);
  }

  selectTab() {
    this.tabsCtrl.selectTab(this);
  }
}

export const TabComponentModule = angular.module('acme.common.component.tabs.tab', []).component('acmeTab', {
  templateUrl: 'common/components/tabs/tab.component.tpl.html',
  controller: TabController,
  require: {
    tabsCtrl: '^acmeTabs',
  },
  transclude: true,
  bindings: {
    name: '<',
    title: '<',
    selected: '<',
  },
}).name;
